function loadMaster(view) {
    return () => import( /* webpackChunkName: "master-[request]" */ `../components/Master/${view}.vue`)
}
function loadViewMaster(view){
    return () => import( /* webpackChunkName: "master-[request]" */ `@/views/DataMaster/${view}.vue`)
}

const masterRoute = [
    {
        path: '/semester',
        name: 'Semester',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
        },
        component: loadMaster('Semester')
    },
    {
        path: '/companies',
        name: 'Company',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi','mahasiswa']
        },
        component: loadMaster('Company')
    },
    {
        path: '/companytypes',
        name: 'CompanyType',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadMaster('CompanyType')
    },
    {
        path: '/prodi',
        name: 'StudyProgram',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
        },
        component: loadMaster('StudyProgram')
    },
    {
        path: '/department',
        name: 'DepartmentGroup',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
        },
        component: loadViewMaster('DepartmentGroup')
    },
    {
        path: '/prodi/:study_program_id/yudisium',
        name: 'YudisiumRole',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
        },
        component: loadMaster('YudisiumRole')
    },
    {
        path: '/prodi/:type',
        name: 'StudyProgramData',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['wadek','kadep']
        },
        component: loadMaster('StudyProgram')
    },
    {
        path: '/sesi',
        name: 'StudySession',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator']
        },
        component: loadMaster('StudySession')
    },
    {
        path: '/matakuliah',
        name: 'StudyCourse',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator','kaprodi', 'sekprodi','kadep']
        },
        component: loadMaster('StudyCourse')
    },
    {
        path: '/dekan-signature',
        name: 'DekanSignature',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator']
        },
        component: loadMaster('DekanSignature')
    },
    {
        path: '/room',
        name: 'Room',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator']
        },
        component: loadMaster('Room')
    },
    {
        path: '/laboratory',
        name: 'Laboratory',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator']
        },
        component: loadMaster('Laboratory')
    },
    {
        path: '/peran-penguji',
        name: 'ExamTesterRole',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['administrator']
        },
        component: loadMaster('ExamTesterRole')
    },
    {
        path: '/faculty',
        name: 'Faculty',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['superadmin']
        },
        component: loadMaster('Faculty')
    },
    {
        path: '/value-range',
        name: 'ValueRange',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['superadmin']
        },
        component: loadMaster('ValueRange')
    },
]

export default masterRoute
